// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c2c1a04c","821":"cc57f73d"}[chunkId] + ".chunk.js";
};